/* Autogenerated file. Do not edit manually. */

import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { Overrides, Signer } from 'ethers';
import { Contract, ContractFactory, utils } from 'ethers';

import type {
  MogulNFTERC721,
  MogulNFTERC721Interface,
} from '../MogulNFTERC721';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_admin',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'approved',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'previousAdminRole',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'newAdminRole',
        type: 'bytes32',
      },
    ],
    name: 'RoleAdminChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleGranted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleRevoked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ROLE_ADMIN',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'getApproved',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
    ],
    name: 'getRoleAdmin',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'hasRole',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'recipients',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
      {
        internalType: 'string[]',
        name: 'tokenURIs',
        type: 'string[]',
      },
    ],
    name: 'mintBatch',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'string',
        name: 'tokenURI',
        type: 'string',
      },
    ],
    name: 'mintToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'ownerOf',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: 'role',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'tokenURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

export class MogulNFTERC721Factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _admin: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<MogulNFTERC721> {
    return super.deploy(_admin, overrides ?? {}) as Promise<MogulNFTERC721>;
  }
  getDeployTransaction(
    _admin: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_admin, overrides ?? {});
  }
  attach(address: string): MogulNFTERC721 {
    return super.attach(address) as MogulNFTERC721;
  }
  connect(signer: Signer): MogulNFTERC721Factory {
    return super.connect(signer) as MogulNFTERC721Factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MogulNFTERC721Interface {
    return new utils.Interface(_abi) as MogulNFTERC721Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider,
  ): MogulNFTERC721 {
    return new Contract(address, _abi, signerOrProvider) as MogulNFTERC721;
  }
}
